// extracted by mini-css-extract-plugin
export default {"statsCard":"StatisticsCard_statsCard__wm2XL","cardRow":"StatisticsCard_cardRow__OuYAE","cardIcon":"StatisticsCard_cardIcon__Anh0V"};